import React from 'react'
import cx from 'classnames'
import { l } from '@manychat/manyui'

import { useAppSelector } from 'reduxTyped'
import { contentManagementSelectors } from 'apps/cms/store'

import { FlowPickerPreviewContent } from './FlowPickerPreviewContent'

import cm from './FlowPickerPreview.module.css'

export const FlowPickerPreview = () => {
  const lastSelectedFlowId = useAppSelector(contentManagementSelectors.getLastSelectedFlowId)
  const { disableFlowCard } = useAppSelector(contentManagementSelectors.getUi)

  const cmsFlow = useAppSelector((state) =>
    contentManagementSelectors.getFlowById(state, lastSelectedFlowId),
  )

  const isQuickAutomationDisabled = disableFlowCard && cmsFlow?.is_quick_automation
  const getPlaceholderText = () => {
    if (isQuickAutomationDisabled) {
      return l.translate("Quick Automations aren't available to choose here.")
    }
    return l.translate('Select any Automation with a published version to see a preview')
  }

  return (
    <div
      className={cx(
        'flex-shrink-0 flex-col align-center justify-center o-hidden p-relative',
        cm.wrapper,
        { [cm.flowSelected]: lastSelectedFlowId && !isQuickAutomationDisabled },
      )}
    >
      {lastSelectedFlowId && cmsFlow && !isQuickAutomationDisabled ? (
        <FlowPickerPreviewContent lastSelectedFlowId={lastSelectedFlowId} cmsFlow={cmsFlow} />
      ) : (
        <div className="text-center">
          <div className="text-subheading m-b-xxs">{l.translate('Preview Automation')}</div>
          <div className="text-secondary">{getPlaceholderText()}</div>
        </div>
      )}
    </div>
  )
}
